export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">焦点专题</h2>
          <p className="mt-3 text-sm text-foreground-600">韩国漫画人气专题 · 深度推荐合集</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20themed%20illustration%20of%20a%20romantic%20couple%20silhouette%20against%20a%20sunset%20cherry%20blossom%20sky%2C%20soft%20golden%20and%20coral%20lighting%2C%20dreamy%20atmospheric%20scene%20with%20floating%20petals%2C%20warm%20romantic%20mood%2C%20webtoon%20style%20digital%20art%2C%20wide%20cinematic%20composition&width=800&height=500&seq=carousel-01&orientation=landscape"
                alt="韩国漫画 - 浪漫恋爱专题"
                title="韩国漫画必看 | 浪漫恋爱专题"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500 text-white">浪漫恋爱</span>
                <h3 className="text-sm font-medium text-white mt-2">心动必看 · 浪漫恋爱漫画精选</h3>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20illustration%20of%20a%20magical%20dragon%20soaring%20above%20an%20ancient%20floating%20castle%20with%20glowing%20crystals%2C%20mystical%20auras%2C%20warm%20amber%20and%20rose%20sky%20at%20dawn%2C%20epic%20fantasy%20scene%2C%20webtoon%20style%20digital%20art&width=800&height=500&seq=carousel-02&orientation=landscape"
                alt="韩国漫画 - 奇幻冒险专题"
                title="韩国漫画高分推荐 | 奇幻冒险专题"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500 text-white">奇幻冒险</span>
                <h3 className="text-sm font-medium text-white mt-2">异世界穿越 · 奇幻冒险神作合集</h3>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20illustration%20depicting%20an%20intense%20martial%20arts%20battle%20silhouette%20with%20dynamic%20energy%20waves%20clashing%2C%20dramatic%20warm%20sunset%20sky%2C%20powerful%20action%20pose%2C%20webtoon%20style%20digital%20art%20with%20cinematic%20wide%20composition&width=800&height=500&seq=carousel-03&orientation=landscape"
                alt="韩国漫画 - 热血动作专题"
                title="韩国漫画人气榜 | 热血动作专题"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500 text-white">热血动作</span>
                <h3 className="text-sm font-medium text-white mt-2">燃爆全场 · 热血动作漫画推荐</h3>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20themed%20illustration%20showing%20a%20mysterious%20shadowy%20figure%20in%20a%20foggy%20alley%20at%20night%2C%20warm%20streetlamp%20glow%2C%20atmospheric%20suspense%2C%20dark%20and%20moody%20tones%20with%20hints%20of%20coral%20light%2C%20webtoon%20style%20digital%20art%20with%20cinematic%20composition&width=800&height=500&seq=carousel-04&orientation=landscape"
                alt="韩国漫画 - 悬疑惊悚专题"
                title="韩国漫画必看 | 悬疑惊悚专题"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500 text-white">悬疑惊悚</span>
                <h3 className="text-sm font-medium text-white mt-2">烧脑神作 · 悬疑惊悚漫画特辑</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}